import {
  ContractorAgreementStage,
  ContractorAgreementType,
  ContractorPaymentMethodDetails,
  ExternalContractorPersonalDetails,
} from '@/domains/Contractor/types'

export enum ContractorOnboardingStepName {
  PERSONAL_INFORMATION = 'PERSONAL_INFORMATION',
  PAYMENT_METHOD = 'PAYMENT_METHOD',
  TAX_FORMS = 'TAX_FORMS',
  SIGN_CONTRACT = 'SIGN_CONTRACT',
  REVIEW_AND_SUBMIT = 'REVIEW_AND_SUBMIT',
}

export enum ContractorOnboardingStepState {
  NOT_STARTED = 'NOT_STARTED',
  COMPLETED = 'COMPLETED',
}

export type ContractorOnboardingStep = {
  name: ContractorOnboardingStepName
  state: ContractorOnboardingStepState
}

export type ContractorOnboardingState = {
  businessId: string
  contractorId: string
  personalDetails?: ExternalContractorPersonalDetails | null
  paymentMethodDetails?: ContractorPaymentMethodDetails | null
  contractDetails?: {
    contractId: string
    agreementType: ContractorAgreementType
    agreementStage: ContractorAgreementStage | null
  }
  steps: ContractorOnboardingStep[]
  taxFormDetails?: {
    state: 'UNSIGNED' | 'SIGNED'
    taxFormId: string
    taxFormType: 'W9' | 'W8BEN'
  } | null
}

export enum DolarTagLinkingState {
  NOT_STARTED = 'NOT_STARTED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
  DELETED = 'DELETED',
}

export type ContractorTaxForm = {
  id: string
  type: 'W9' | 'W8BEN'
  state: string
  base64pages: string[]
}
